import styles from "./FormsToolbar.module.scss";
import {
  CalendarDateIcon,
  EyeOffIcon,
  File01Icon,
  FileDownload01Icon,
  SearchSmIcon,
} from "@vetty/icons";
import { Button, Input, Select } from "@/components";
import {
  FORM_APPLICATION_PERIOD_OPTIONS,
  FORM_APPLICATION_STATUS_OPTIONS,
  FORM_APPLICATION_TAB_ITEMS,
} from "../../_constants/formsApplications.const";
import type {
  FormApplicationPeriod,
  FormApplicationStatus,
  FormApplicationTypeFilter,
} from "../../_types/formsApplications.types";

type FormsToolbarProps = {
  type: FormApplicationTypeFilter;
  period: FormApplicationPeriod;
  status: FormApplicationStatus;
  search: string;
  onTypeChange: (value: FormApplicationTypeFilter) => void;
  onPeriodChange: (value: FormApplicationPeriod) => void;
  onStatusChange: (value: FormApplicationStatus) => void;
  onSearchChange: (value: string) => void;
  onExportClick: () => void;
};

export const FormsToolbar = ({
  type,
  period,
  status,
  search,
  onTypeChange,
  onPeriodChange,
  onStatusChange,
  onSearchChange,
  onExportClick,
}: FormsToolbarProps) => {
  return (
    <div className={styles["comp"]}>
      <div className={styles["comp__left"]}>
        <Select
          size="medium"
          variant="secondary"
          value={type}
          startContent={<File01Icon style={{ width: 20, height: 20 }} />}
          onChange={(value) => onTypeChange(value as FormApplicationTypeFilter)}
        >
          {FORM_APPLICATION_TAB_ITEMS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>

        <Select
          size="medium"
          variant="secondary"
          value={period}
          startContent={<CalendarDateIcon style={{ width: 20, height: 20 }} />}
          onChange={(value) => onPeriodChange(value as FormApplicationPeriod)}
        >
          {FORM_APPLICATION_PERIOD_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>

        <Select
          size="medium"
          variant="secondary"
          value={status}
          startContent={<EyeOffIcon style={{ width: 20, height: 20 }} />}
          onChange={(value) => onStatusChange(value as FormApplicationStatus)}
        >
          {FORM_APPLICATION_STATUS_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>

        <div className={styles["comp__search"]}>
          <Input
            id="forms-search"
            value={search}
            placeholder="Search by name, email, company…"
            variant="secondary"
            size="medium"
            startContent={<SearchSmIcon style={{ width: 20, height: 20 }} />}
            onChange={(value) => onSearchChange(value)}
          />
        </div>
      </div>

      <div className={styles["comp__actions"]}>
        <Button
          size="medium"
          variant="primary"
          startContent={<FileDownload01Icon style={{ width: 20, height: 20 }} />}
          onClick={onExportClick}
        >
          Export
        </Button>
      </div>
    </div>
  );
};
